import { COGNITO_IU } from '@loggi/authentication-lib';

// This is necessary, because sometimes Amplify was return false when was not loading, but did not load property the user
const isImpersonated = () => Boolean(localStorage.getItem(COGNITO_IU));

export default isImpersonated;
